import { z } from "zod";

//DiarioObrasAtividadesSchema

const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);

export const DiarioObrasAtividadesSchema = z.object({
  IdDiarioObrasAtividades: z.number().int().default(0),
  IdDiarioObras: optionalNumber,
  Descricao: optionalString.pipe(z.string().max(3000, "Máximo de 3000 caracteres").nullable().optional()),
  IdFornecedor: optionalNumber,
  TipoMaoDeObra: optionalNumber,
  Ordem: optionalNumber,
 
});

// DiarioObrasEfetivoForm
export type DiarioObrasAtividadesForm = z.infer<typeof DiarioObrasAtividadesSchema>;